<ngx-select [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name"
    [disabled]="ngxDisabled" [autoClearSearch]="false" [(ngModel)]="productTypeSales"
    placeholder="Seleccionar Producto" (select)="changeProductTypeSales($event)">

    <ng-template ngx-select-option-not-found let-input>
        "{{input}}" no encontrado
    </ng-template>

</ngx-select>